import GroupedOfferingTab from "./GroupedOfferingTab";

export default function OfferingTab({ list, lastItemRef, loading, onChanged }) {
  return (
    <GroupedOfferingTab
      list={list}
      lastItemRef={lastItemRef}
      loading={loading}
      onChanged={onChanged}
    />
  );
}
